import React, { Component } from 'react';
import { Icon } from 'antd';
import Slider from 'react-slick';

export default class Instructors extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }
  
  render(){
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1
        
      };
      return(
          <div>
              <div class="our-instructor">
				<div class="container">
					<div class="theme-title text-center">
						<h2>Our Instructors</h2>
						<p>Other technological advances made during the Paleolithic era were clothing and </p>
					</div>

					<div class="row">
						<div class="instructor-slider">
                            <Slider autoplay {...settings}>
							<div class="item">
								<div class="single-member">
									<div class="image">
										<img src="img/team/1.jpg" alt=""/>
										<div class="opacity tran4s">
											<ul>
									        	<li><a href="#" class="tran3s"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
									        </ul>
										</div>
									</div>
									<h6><a href="teachers-profile.html" class="tran3s">Jubayer Hasan</a></h6>
									<p>Web Design &amp; Developer</p>
								</div>
							</div> 
							<div class="item">
								<div class="single-member">
									<div class="image">
										<img src="img/team/2.jpg" alt=""/>
										<div class="opacity tran4s">
											<ul>
									        	<li><a href="#" class="tran3s"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
									        </ul>
										</div>
									</div>
									<h6><a href="teachers-profile.html" class="tran3s">Solayman Mi.</a></h6>
									<p>Senior Designer</p>
								</div>
							</div> 
							<div class="item">
								<div class="single-member">
									<div class="image">
										<img src="img/team/3.jpg" alt=""/>
										<div class="opacity tran4s">
											<ul>
									        	<li><a href="#" class="tran3s"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
									        </ul>
										</div>
									</div>
									<h6><a href="teachers-profile.html" class="tran3s">Lopa Murai</a></h6>
									<p>Photographer</p>
								</div>
							</div> 
							<div class="item">
								<div class="single-member">
									<div class="image">
										<img src="img/team/4.jpg" alt=""/>
										<div class="opacity tran4s">
											<ul>
									        	<li><a href="#" class="tran3s"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
									        </ul>
										</div>
									</div>
									<h6><a href="teachers-profile.html" class="tran3s">Hasan Masud</a></h6>
									<p>TV Artist</p>
								</div>
							</div> 
							<div class="item">
								<div class="single-member">
									<div class="image">
										<img src="img/team/5.jpg" alt=""/>
										<div class="opacity tran4s">
											<ul>
									        	<li><a href="#" class="tran3s"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
									        </ul>
										</div>
									</div>
									<h6><a href="teachers-profile.html" class="tran3s">Suraiya Khatun</a></h6>
									<p>Art &amp; Illustrator Expert</p>
								</div>
							</div> 
							<div class="item">
								<div class="single-member">
									<div class="image">
										<img src="img/team/6.jpg" alt=""/>
										<div class="opacity tran4s">
											<ul>
									        	<li><a href="#" class="tran3s"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
									        </ul>
										</div>
									</div>
									<h6><a href="teachers-profile.html" class="tran3s">Abdus Salam</a></h6>
									<p>UI/UX Desginer at Unify</p>
								</div>
							</div> 
							<div class="item">
								<div class="single-member">
									<div class="image">
										<img src="img/team/7.jpg" alt=""/>
										<div class="opacity tran4s">
											<ul>
									        	<li><a href="#" class="tran3s"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
									        </ul>
										</div>
									</div>
									<h6><a href="teachers-profile.html" class="tran3s">Sayfur Rahman</a></h6>
									<p>Front-End Developer</p>
								</div>
							</div> 
							<div class="item">
								<div class="single-member">
									<div class="image">
										<img src="img/team/8.jpg" alt=""/>
										<div class="opacity tran4s">
											<ul>
									        	<li><a href="#" class="tran3s"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
									        </ul>
										</div>
									</div>
									<h6><a href="teachers-profile.html" class="tran3s">Jhon Doe</a></h6>
									<p>Marketing Expert</p>
								</div>
							</div> 
							<div class="item">
								<div class="single-member">
									<div class="image">
										<img src="img/team/5.jpg" alt=""/>
										<div class="opacity tran4s">
											<ul>
									        	<li><a href="#" class="tran3s"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
									        	<li><a href="#" class="tran3s"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
									        </ul>
										</div>
									</div>
									<h6><a href="teachers-profile.html" class="tran3s">Suraiya Khatun</a></h6>
									<p>Art &amp; Illustrator Expert</p>
								</div>
							</div> 
                        </Slider>
					</div>
						</div> 
				</div>
			</div> 
          </div>
      )
  }
}
